import { Dashboard } from "views/app/index";
import TermAndCondition from "views/pages/superAdmin/TermsAndConditions/TermAndCondition";
import EditProfile from "views/pages/superAdmin/EditProfile";
import ChangePassword from "views/pages/superAdmin/ChangePassword";
import merchantList from "views/pages/users/MerchantList";
import EditSubscription from "views/pages/subscription/EditSubscription";
import MerchantChangePassword from "views/pages/merchant/ChangePassword";
import MerchantEditProfile from "views/pages/merchant/EditProfile";
import UserList from "views/pages/users/UserList";
import SubscriptionPage from "views/pages/subscription/Merchant/SubscriptionPage";
import SubscriptionSuccess from "views/pages/subscription/Merchant/SubscriptionSuccess";
import PrivacyPolicy from "views/pages/superAdmin/PrivacyPolicy/PrivacyPolicy";
import Report from "views/pages/merchant/Report/Report";
import SubscriptionHistories from "views/pages/superAdmin/SubscriptionHistories";
import UsersMerchantList from "views/pages/superAdmin/UsersMerchantList";
import MerchantDashboard from "views/pages/merchant/MerchantDashboard";
import CallLogs from "views/pages/users/CallLogs";
import UserLogs from "views/pages/users/UserLogs";
import SubscriptionHistory from "views/pages/subscription/Merchant/SubscriptionHistory";

const dashboardRoutes = [
  { path: "/admin/dashboard", component: Dashboard },
  { path: "/admin/change-password", component: ChangePassword },
  { path: "/admin/profile", component: EditProfile },
  { path: "/admin/merchants", component: merchantList },
  { path: "/admin/user-list", component: UsersMerchantList },
  { path: "/admin/subscription/edit", component: EditSubscription },
  { path: "/admin/transactions", component: SubscriptionHistories },
  { path: "/admin/terms-and-conditions", component: TermAndCondition },
  { path: "/admin/privacy-policy", component: PrivacyPolicy },

  { path: "/dashboard", component: MerchantDashboard },
  { path: "/change-password", component: MerchantChangePassword },
  { path: "/profile", component: MerchantEditProfile },
  { path: "/users", component: UserList },
  { path: "/call-logs", component: CallLogs },
  { path: "/user-logs/:userId/:userName", component: UserLogs },
  { path: "/subscription", component: SubscriptionPage },
  { path: "/subscription-history", component: SubscriptionHistory },
  // Payment History
  {
    path: "/subscription/success",
    component: SubscriptionSuccess,
    module: "subscription"
  },
  { path: "/report", component: Report }
];
export default dashboardRoutes;
